/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Actualsetpoint1Inputs */



/**
* | output |
* | --- |
* | "Actual setpoint" |
*
* @param {Ahu_History_Key_Actualsetpoint1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_actualsetpoint1 = /** @type {((inputs?: Ahu_History_Key_Actualsetpoint1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Actualsetpoint1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Actual setpoint")
	return /** @type {LocalizedString} */ ("Consigne réelle")
});
export { ahu_history_key_actualsetpoint1 as "ahu_history_key_actualSetpoint" }